// removed by extract-text-webpack-plugin
module.exports = {"footerContent":"_13gcVZL_-0PP-RnzaWk6fn","linkColor":"_33s7ux6EN4NOypfCQot4Qo"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UserAuthentication/ForgotPassword/ForgotPasswordFooter/ForgotPasswordFooter.scss
// module id = 1784
// module chunks = 0